import { render, staticRenderFns } from "./index-marketing.vue?vue&type=template&id=4ed95534&"
import script from "./index-marketing.vue?vue&type=script&lang=js&"
export * from "./index-marketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports